import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import { getTeachers } from "../../../services/user.service";
import { getSessionGroups } from "../../../services/sessionGroup.service";

// Options pour le tri
const sortingOptions = ["Plus récents", "Plus anciens", "Date de début"];

// Options pour le statut
const statusOptions = ["Tous", "Ouvert", "Fermé"];

const Settings = ({ onFiltersChange }) => {
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [statusFilter, setStatusFilter] = useState(statusOptions[0]);
  
  // Nouveaux états pour les filtres professeur et groupe
  const [teachers, setTeachers] = useState([]);
  const [sessionGroups, setSessionGroups] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);

  // Charger les professeurs au montage
  useEffect(() => {
    const fetchTeachers = async () => {
      setLoadingTeachers(true);
      try {
        const result = await getTeachers();
        const teacherOptions = result.map(teacher => ({
          value: teacher.id,
          title: `${teacher.first_name} ${teacher.last_name}`
        }));
        setTeachers([{ value: null, title: "Tous les professeurs" }, ...teacherOptions]);
      } catch (error) {
        console.error('Erreur lors du chargement des professeurs:', error);
        setTeachers([{ value: null, title: "Tous les professeurs" }]);
      } finally {
        setLoadingTeachers(false);
      }
    };
    fetchTeachers();
  }, []);

  // Charger les groupes de sessions au montage
  useEffect(() => {
    const fetchGroups = async () => {
      setLoadingGroups(true);
      try {
        const result = await getSessionGroups({ page: 1, perPage: 1000 });
        const groupOptions = (result.items || []).map(group => ({
          value: group.id,
          title: group.title
        }));
        setSessionGroups([{ value: null, title: "Tous les groupes" }, ...groupOptions]);
      } catch (error) {
        console.error('Erreur lors du chargement des groupes:', error);
        setSessionGroups([{ value: null, title: "Tous les groupes" }]);
      } finally {
        setLoadingGroups(false);
      }
    };
    fetchGroups();
  }, []);

  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setStatusFilter(statusOptions[0]);
    setSelectedTeacher(null);
    setSelectedGroup(null);
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        statusFilter: "tous",
        teacherId: null,
        groupId: null
      });
    }
  };

  const applyFilters = () => {
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        statusFilter: statusFilter === "Tous" ? "tous" : statusFilter,
        teacherId: selectedTeacher?.value || null,
        groupId: selectedGroup?.value || null
      });
    }
  };

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={statusFilter}
            setValue={setStatusFilter}
            options={statusOptions}
            label="Statut"
          />
        </div>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={selectedTeacher}
            setValue={setSelectedTeacher}
            options={teachers}
            label="Professeur"
            placeholder={loadingTeachers ? "Chargement..." : "Tous les professeurs"}
          />
        </div>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={selectedGroup}
            setValue={setSelectedGroup}
            options={sessionGroups}
            label="Groupe"
            placeholder={loadingGroups ? "Chargement..." : "Tous les groupes"}
          />
        </div>
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
